module.exports = __webpack_public_path__ + "static/img/team_control.4c18cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/team_control.png
// module id = QMGb
// module chunks = 1